export const initialState = {
    loader: false,
    user: {},
    error: ''
}